export default {
  props: {
    // 业务类型
    businessType: String,
    // 需要隐藏的列
    hiddenColumns: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getConfigApi() {
      return this.$MGUI?.table?.getColumnApi
    },
    saveConfigApi() {
      return this.$MGUI?.table?.setColumnApi
    },
    renderVisibleColumns() {
      return this.renderColumns.filter((col) => !this.hiddenColumns.includes(col.prop))
    },
  },
  data() {
    return {
      renderColumns: [...this.columns],
      globalTableConfigId: null,
    }
  },
  async created() {
    if (this.businessType && this.getConfigApi) {
      const { data } = await this.getConfigApi(this.businessType)
      this.globalTableConfigId = data?.globalTableConfigId ?? null
      if (!data?.columnData) return

      const remoteColumns = JSON.parse(data.columnData)
      const localColumns = [].concat(this.columns)
      const sortColumns = localColumns.sort((a, b) => {
        const Aindex = remoteColumns.findIndex((item) => item.prop === a.prop)
        if (Aindex == -1) return 0
        const Bindex = remoteColumns.findIndex((item) => item.prop === b.prop)
        if (Bindex == -1) return 1
        return Aindex - Bindex
      })
      // 列宽已服务器保存的数据为主（列表，是否隐藏，是否可编辑）
      sortColumns.forEach((item) => {
        const column = remoteColumns.find((col) => item.prop === col.prop)
        if (column) {
          item.width = column.width || item.width
          item.minWidth = column.minWidth || item.minWidth
          item.hidden = column.hidden
          item.edit = column.edit || item.edit
        }
      })
      // 更新列
      this.renderColumns = sortColumns
      this.handleColumnChange(sortColumns)
    }
  },
  methods: {
    // 虚拟表格列宽调整
    resizableChange({ column }) {
      let col = {}
      if (column?.params?.default) {
        col = this.renderColumns.find((item) => item.label === column.title)
      } else {
        col = this.renderColumns.find((item) => item.prop === column.property)
      }
      col.minWidth = Math.ceil(column.resizeWidth)
      col.width = Math.ceil(column.resizeWidth)
      this.handleColumnChange(this.renderColumns, false)
    },
    /**
     * 调整列宽
     */
    handleHeaderDragEnd(newWidth, oldWidth, column, event) {
      if (typeof this.$attrs['header-dragend'] === 'function') {
        this.$attrs['header-dragend'](newWidth, oldWidth, column, event)
      }
      const col = this.renderColumns.find((item) => item.prop === column.property)
      if (Math.abs(newWidth - oldWidth) <= 5) return
      col.minWidth = Math.ceil(newWidth)
      col.width = Math.ceil(newWidth)
      this.handleColumnChange(this.renderColumns, false)
    },
    /**
     * 响应列改变得事件
     */
    handleColumnChange(columns, needUpdateColumn = true) {
      this.$emit('column-change', [...columns])
      if (this.businessType && this.saveConfigApi) {
        this.saveConfigApi({
          businessType: this.businessType,
          columnData: JSON.stringify(columns),
          globalTableConfigId: this.globalTableConfigId ?? null,
        }).then((res) => {
          if (res.data) {
            if (needUpdateColumn) {
              this.renderColumns = []
              this.$nextTick(() => {
                this.renderColumns = columns
              })
            }
            this.globalTableConfigId = res.data
          }
        })
      }
    },
  },
}
